import { Component, OnInit, AfterViewInit, Input } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../auth.service';
import { AppCommonService } from '../appcommon.service';
import { IBlog, IOffer } from '../blogs/blog';
import { BlogService } from '../blogs/blog.service';

@Component({
  selector: 'mft-relatedoffers',
  templateUrl: "./relatedoffers.component.html"
})
export class RelatedOffersComponent implements OnInit, AfterViewInit {
  @Input() offersList: IOffer[];
  @Input() category: string;
  constructor(private authService: AuthService,
    private appCommonService: AppCommonService,
    private router: Router,
    public blogService: BlogService,
  ) {

  }
  ngOnInit() {

  }

  ngAfterViewInit() {
   
  }
}



// WEBPACK FOOTER //
// ./src/app/genericpages/relatedoffers.component.ts